import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { AuthSession } from '../../../../types/plans'
import type { ConstructorPlan } from '../constructorTypes'
import type { DiagnocatPresentationPhase } from './domain/diagnocatWorkflow'
import { GammaPresentationStep } from '../presentation/GammaPresentationStep'

export function PlanGammaPresentationStep({
  bootstrap,
  session,
  misPatientId,
  planId,
  planDetail,
}: {
  bootstrap: TenantBootstrapModel
  session: AuthSession
  misPatientId: string
  planId: string
  planDetail?: ConstructorPlan | null
  onPresentationPhaseChange?: (phase: DiagnocatPresentationPhase) => void
}) {
  const detail: ConstructorPlan = planDetail ?? { id: Number(planId) || 0, mis_plan_id: planId }
  return (
    <GammaPresentationStep
      bootstrap={bootstrap}
      session={session}
      planDetail={detail}
      misPatientId={misPatientId}
    />
  )
}
